import api from '@/utils/api'

export default {
    getPrivileges() {
        return api.get('user-privileges')
    }
}
